
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class BPSectionHeader extends Vue {
  @Prop({
    type: String,
    required: true,
    default: '',
  })
  title!: string

  @Prop({
    type: String,
    required: false,
    default: '',
  })
  subTitle!: string
}
